import Blue from "~/core";

new Blue({
    name: "CareerCompare",
    selector: ".aviation-career-compare",
    setup() {
        const removeCareerButtons = document.querySelectorAll('.career-comparison__remove-career-button');
        const careerComparisonWrapper = document.querySelector('.aviation-career-compare__content-wrapper');
        const NoCareersSelectedMessage = `<p>Go to the <a href="${careerSearchUrl}" target="_self">Career Search Page</a> and add careers</p>`

        removeCareerButtons.forEach(element => {
            element.addEventListener('click', () => {
                removeCareerColumn(element);

                updateCareersForComparisonCookie();              
                
                if (hasNoCareersForComparison()) {
                    careerComparisonWrapper.innerHTML = NoCareersSelectedMessage;
                }
                
            });
        });

        function removeCareerColumn(element) {
            const careerToRemove = element.dataset.careertoremove;
            const tableCellsToRemove = document.querySelectorAll(`[data-careerguid="${careerToRemove}"]`);

            tableCellsToRemove.forEach(tableCell => {
                tableCell.remove();
            });
        }

        function updateCareersForComparisonCookie() {
            var careersForComparison = '';
        
            document.querySelectorAll(".career-comparison__header-item-wrapper").forEach(element => {
                careersForComparison += `${element.dataset.careerguid},`;
            });
        
            careersForComparison = encodeURIComponent(careersForComparison);
        
            document.cookie = `CareersForComparison=${careersForComparison};  path=/`;
        }

        function hasNoCareersForComparison() {
            const remainingCareersForComparison = document.querySelectorAll(".career-comparison__header-item-wrapper")

            return remainingCareersForComparison.length === 0;
        }
    }
});
